/**
 *
 * 百度地图相关方法
 *
 */

export default {
  echartsAddMarkPoint (title, color) {
    return {
      symbol: 'circle',
      // symbolSize: 10,
      effect: {
        type: 'scale',
        show: true,
        shadowBlur: 0
      },
      itemStyle: {
        normal: {
          color: color,
          label: {
            show: false
          }
        }
      },
      data: [{
        name: title
      }]
    }
  },
  echartsAddMarkLine (src, dest, color) {
    return {
      smooth: true,
      effect: {
        show: true,
        loop: false,
        scaleSize: 3,
        period: 8,
        color: color
      },
      symbolSize: [0, 0],
      large: true,
      itemStyle: {
        normal: {
          borderWidth: 1,
          lineStyle: {
            type: 'solid',
            color: 'rgba(0, 0, 0, 0)'
          }
        }
      },
      data: [
        [{
          name: src
        }, {
          name: dest
        }]
      ]
    }
  }
}
